import React from "react";

import SideMenu from "./Sidemenu/Sidemenu"
import Header from "./Header/Header";
import Footer from "./Footer/Footer";

import { AlignVerticalBetween, Content, Main, Menu, Wrapper } from './Layout.styles'

export const Layout = ({ children, ...rest }) => (
  <Wrapper {...rest}>
    <Menu>
      <SideMenu />
    </Menu>
    <Content>
      <Header />
      <AlignVerticalBetween>
        <Main>{children}</Main>
        <Footer />
      </AlignVerticalBetween>
    </Content>
  </Wrapper>
);
